module.exports = __webpack_public_path__ + "static/media/event-services-img21.56df2d9e.jpg";